import { render, staticRenderFns } from "./CreateAlbum.vue?vue&type=template&id=5303dc52"
import script from "./CreateAlbum.vue?vue&type=script&lang=js"
export * from "./CreateAlbum.vue?vue&type=script&lang=js"
import style0 from "./CreateAlbum.vue?vue&type=style&index=0&id=5303dc52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports